import React, { useEffect, useState, useCallback } from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";
import PageHero from "../components/PageHero";
import EventCard from "../components/EventCard";
import { API_URL } from "../config";
import photoWorship from "../assets/images/church.jpg";

function PublicEvents() {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const fetchEvents = useCallback(async () => {
        try {
            const response = await fetch(`${API_URL}/events/public/upcoming`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (response.ok) {
                const data = await response.json();
                setEvents(data.events || []);
            } else {
                throw new Error("Failed to fetch events");
            }
        } catch (error) {
            setError("An error occurred while fetching events.");
            console.error("Error:", error);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchEvents();
    }, [fetchEvents])

    return (
        <div className="cf-public">
            <Header />

            <main>
                <PageHero photo={photoWorship} eyebrow="Events" title="Upcoming events">
                    Conferences, reflections and other times when the ministry comes together.
                    Open an event to see its date, its venue and how to register.
                </PageHero>

                <section className="cf-sec">
                    <div className="cf-wrap">
                        {error && <p className="cf-empty is-bad" role="alert">{error}</p>}

                        {!error && loading && <p className="cf-empty">Loading. Please wait ...</p>}

                        {!error && !loading && events.length === 0 && (
                            <p className="cf-empty">No events have been announced yet. Please check again soon.</p>
                        )}

                        {events.length > 0 && (
                            <div className="cf-events">
                                {events.map((event) => (
                                    <EventCard event={event} key={event.id} />
                                ))}
                            </div>
                        )}
                    </div>
                </section>
            </main>

            <Footer />
        </div>
    );
}

export default PublicEvents;
